import template from './invoice-create-other.html';
import controller from './invoice-create-other.controller';

let invoiceCreateOtherComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default invoiceCreateOtherComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create-other/invoice-create-other.component.js